export const styles = theme => ({
  paper:{
    margin:"10px"
  },  
  pContainer:{
    display: "flex",
    alignItems: "center",
    height: "200px",
    padding: "70px",
    flexDirection:"column"
  },
  progress: {
    // margin: theme.spacing.unit * 2,
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: '#F0F0F8',
  },
  header: {
    width: '100%',
    paddingBottom: 20,
    marginBottom: 20,
    backgroundColor: 'black',
    boxShadow: '-10px 9px 12px 0px #00000040',
  },
  headerContent: {
    width: '84%',
    height: 70,
    margin: 'auto',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  headerButtons: {
    display: 'flex',
    width: 220,
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  headerFont: {
    color: 'white',
    fontWeight: 'bold',
  },
  subheaderFont: {
    color: 'white',
    fontWeight: 'bold',
  },
  footer: {
    backgroundColor: 'black',
    width: '100%',
    padding: 20,
    marginTop: 20,
    color: '#808080',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  cardGrid: {
    display: 'flex',
    alignItems: 'center',
    padding: 20,
    justifyContent:"space-around"
  },
  left:{
    width: "30%"
  },
  right:{
    width:"70%"
  }
});
